import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export default createTypes(
  'GET_COMPANY_OVERVIEW',
  'GET_COMPANY_CERTIFICATIONS',
  'CHANGE_PARAMS_CERTIFICATIONS',
  'GET_COMPANY_DOCUMENTATIONS',
  'CHANGE_PARAMS_DOCUMENTATION'
);
